module.exports = __webpack_public_path__ + "img/15-green.cb663c71.svg";